import React from 'react'
import { StateResultsProvided } from 'react-instantsearch-core'
import { connectStateResults } from 'react-instantsearch-dom'

interface ResultsProps extends StateResultsProvided {
  noResults: string
  children: React.ReactNode
}

function Results({ searchResults, children, noResults }: ResultsProps): React.ReactElement {
  return searchResults && searchResults.nbHits !== 0 ? <div>{children}</div> : <p className="p-16">{noResults}</p>
}

export const SearchResults = connectStateResults(Results)
